export const parseTrueFalseNullText = (value) => {
  let text;
  if (value === true) {
    text = 'Ja';
  } else if (value === false) {
    text = 'Nee';
  } else {
    text = 'Onbekend';
  }

  return text;
};

export const booleanText = (bool) => (bool ? 'Ja' : 'Nee');

export const parseCopyRightText = (obj) => {
  if (!obj.imageLicense) {
    return null;
  }

  return `${obj.imageLicense}: ${obj.copyrightText}`;
};
